import styled from 'styled-components';

import { colors } from 'styles/colors';

const defineLabelColor = (error, disabled) => {
  if (error) {
    return colors.Red;
  }
  if (disabled) {
    return colors.Grey200;
  }
  return colors.Blue700;
};

export const BaseSpan = `
  color: ${colors.Blue700};
  font-size: 0.75em;
  font-weight: bold;
  top: 15px;
`;

export const Base = styled.input<{ error, suffixLength?, hasLabel?: boolean }>(
  ({ error, suffixLength, hasLabel }) => `
    outline: none;
    min-height: 48px;
    font-size: 1em;
    border-radius: 5px;
    padding: ${hasLabel ? `25px ${suffixLength ? `${suffixLength * 9}px` : '35px'} 10px 14px` : `14px ${suffixLength ? `${suffixLength * 9}px` : '35px'} 14px 14px`};
    color: ${colors.Black};
    width: 100%;
    border: 1px solid ${error ? colors.Red : colors.Grey050};

    &:focus {
      outline: none;
      border-color: ${error ? colors.Red : colors.Blue700};
    }

    &::placeholder {
      font-size: ${hasLabel ? '12px' : '14px'};
      color: ${hasLabel ? 'transparent' : colors.GreyInputPlaceholder};
    }
    ::-webkit-inner-spin-button{
      appearance: none;
      margin: 0;
    }
    ::-webkit-outer-spin-button{
        appearance: none;
        margin: 0;
    }
`,
);

export const Container = styled.div`
  position: relative;
  border-radius: 5px;
`;

export const Label = styled.label<{ error, disabled, value, suffixLength?, noSuffixBorder? }>(
  ({
    error,
    disabled,
    value,
    suffixLength,
    noSuffixBorder,
  }) => `
    position: relative;
    display: inline-block;
    width: 100%;
    cursor: ${disabled ? 'not-allowed' : 'default'};
    span:first-of-type {
      transition: 0.2s all ease-in-out;
      position: absolute;
      left: 15px;
      cursor: auto;
      top: 60%;
      transform: translateY(-50%);
      font-size: 14px;
      font-weight: normal;
      color: ${colors.Grey300};
      ${value ? `
        top: 15px;
        transform: none;
        font-size: 0.75em;
        font-weight: bold;
        color: ${defineLabelColor(error, disabled)};
      ` : ''}
    }

    span:nth-child(3) {
      position: absolute;
      width: auto;
      padding: 5px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
      color: #818181;
      right: 10px;
      top: calc(50% - 4px);
      background-color: #F2F0F0;
      ${!noSuffixBorder && 'border: 1px solid #ccc;'}
      white-space: nowrap;
      vertical-align: middle;
      border-radius: 5px;
    }

    &:focus-within {
      span:first-of-type {
        top: 15px;
        transform: none;
        font-size: 0.75em;
        font-weight: bold;
        color: ${defineLabelColor(error, disabled)};
      }
    }
  `,
);

export const Error = styled.span`
  color: ${colors.Red};
  display: block;
  margin: 5px;
  text-align: left;
  font-size: 0.75em;
  height: 24px;
`;

export const IconWrapper = styled.div<{ placement: 'end' }>`
  position: absolute;
  display: inline-block;
  width: 14px;
  height: 14px;
  right: 18px;
  top: calc(50% - 12px);

  svg {
    width: 18px;
    height: 18px;
  }
`;
